export default __webpack_public_path__ + "static/media/sanmar5.d49b7587.jpg";